// HELPERS
import { usePrefixedMessage } from '../../../utils/content'
import { usePrefixedContent } from '../../../utils/content-helpers'

// REDUX
import { RootState } from '@/redux/store'
import { useReduxState } from '../../../hooks/redux'
import { BUSINESS_PROFILE_REDUCER } from '../../../constants/redux'

// CONSTANTS
import {
  BUSINESS_PROFILE_PAGE_CONTENT_PATH,
  MODULAR_SELLER_PAGE_CONTENT_PATH,
} from '../constants/content-paths'

export * from './api'
export * from './errors'

/**
 * Use content specific to the label details page properties
 */
export function useBusinessProfilePageContent() {
  return usePrefixedContent(BUSINESS_PROFILE_PAGE_CONTENT_PATH)
}

/**
 * Use content specific to the label details page properties
 */
export function useBusinessProfilePageMessage() {
  return usePrefixedMessage(BUSINESS_PROFILE_PAGE_CONTENT_PATH)
}

/**
 * Retrieves the business profile redux state
 */
export function useBusinessProfileReduxState() {
  return useReduxState(
    BUSINESS_PROFILE_REDUCER,
  ) as RootState[typeof BUSINESS_PROFILE_REDUCER]
}

/**
 * Use content specific to the modular seller view page properties
 */
export function useModularSellerViewPageContent() {
  return usePrefixedContent(MODULAR_SELLER_PAGE_CONTENT_PATH)
}
